import undelegateListener from '../../off/_undelegatelistener.js';
import delegateListener from './index.js';
import triggerOne from '../../trigger/_triggerone.js';
// the function is called when some part of a path is changed
// it delegates event listener for new branch of an object and undelegates it for old one
// used for non-asterisk events
export default function changeHandler(_ref, _temp) {
  var previousValue = _ref.previousValue,
    value = _ref.value;
  var _ref2 = _temp === void 0 ? triggerOne.latestEvent.info.delegatedData : _temp,
    path = _ref2.path,
    name = _ref2.name,
    callback = _ref2.callback,
    context = _ref2.context,
    info = _ref2.info;
  // the old branch goes first: a branch the new value shares with it keeps the listener
  if (previousValue && typeof previousValue === 'object') {
    undelegateListener(previousValue, path, name, callback, context, info);
  }
  if (value && typeof value === 'object') {
    delegateListener(value, path, name, callback, context, info);
  }
}